<template>
  <form-group class="ma-0 pa-0">
    <analysis-info-card
      v-model="payload"
      :loading="loading"
    />
    <analysis-table-reasons-card
      v-model="payload"
      :loading="loading"
    />
    <client-company-info-card
      v-model="payload"
      :loading="loading"
    />
    <client-company-big-data-info-card
      v-model="payload"
      :loading="loading"
    />
    <client-data-ocr-info-card
      v-model="payload"
      :loading="loading"
    />
  </form-group>
</template>

<script>
import AnalysisTableRequest from 'Modules/contacard/analysisTable/AnalysisTableRequest';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import AnalysisInfoCard from 'Modules/contacard/analysisTable/components/cards/AnalysisInfoCard.vue';
import ClientCompanyInfoCard from 'Modules/contacard/analysisTable/components/cards/ClientCompanyInfoCard.vue';
import ClientCompanyBigDataInfoCard from 'Modules/contacard/analysisTable/components/cards/ClientCompanyBigDataInfoCard.vue';
import ClientDataOcrInfoCard from 'Modules/contacard/analysisTable/components/cards/ClientDataOcrInfoCard.vue';
import AnalysisTableReasonsCard from 'Modules/contacard/analysisTable/components/cards/AnalysisTableReasonsCard.vue';

export default {
  name: 'AnalysisClientInfoDisplay',
  components: {
    FormGroup,
    AnalysisInfoCard,
    ClientCompanyInfoCard,
    ClientCompanyBigDataInfoCard,
    ClientDataOcrInfoCard,
    AnalysisTableReasonsCard,
  },
  mixins: [ServiceMixin],
  data: () => ({
    requestClass: AnalysisTableRequest,
    loading: false,
    payload: {
      companyDataByUser: {
        companyName: '',
        cpfCnpj: '',
        tradingName: '',
        stateRegistration: '',
      },
      companyDataByBigData: {
        cnpj: '',
        companyName: '',
        stateRegistration: '',
        tradingName: '',
      },
      businessAddressesByBigData: [
        {
          postalCode: '',
          street: '',
          number: '',
          complement: '',
          neighborhood: '',
          city: '',
          state: '',
        },
      ],
      dataByUser: {
        name: '',
        cpf: '',
        rg: '',
        dateOfBirth: '',
        mothersName: '',
      },
      dataByBigData: {
        name: '',
        cpf: '',
        rg: '',
        dateOfBirth: '',
        mothersName: '',
      },
      personalAddress: {
        postalCode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
      },
      dataByOcrFront: {
        fathersName: '',
        documentType: '',
        name: '',
        cpf: '',
        rg: '',
        dateOfBirth: '',
        mothersName: '',
      },
      dataByOcrBack: {
        fathersName: '',
        documentType: '',
        name: '',
        cpf: '',
        rg: '',
        dateOfBirth: '',
        mothersName: '',
      },
      businessAddress: {
        postalCode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
      },
      contact: {
        email: '',
        cellPhone: '',
        deviceId: '',
      },
      store: {
        id: '',
        status: '',
        step: '',
        companyName: '',
        tradingName: '',
        cnpj: '',
        segmentId: '',
        storeId: '',
        annualBilling: '',
        validatedFacade: '',
        storeCreationDate: '',
        analysisTable: '',
      },
      attemptsOcrDocument: '',
      attemptsFaceMatch: '',
      flagDeath: '',
      attemptsPersonalData: '',
      attemptsToken: '',
      validatedDocument: '',
      validatedSelfie: '',
      clientAnalysisTable: '',
      userAnalysisTable: '',
      clientStep: '',
      clientType: '',
      clientStatus: '',
      userStatus: '',
      userStep: '',
      registerUserCreatedAt: '',
      registerClientCreatedAt: '',
      registerClientId: '',
      registerUserId: '',
    },
    requestConfig: {
      errorMessage: 'Falha ao buscar dados de mesa de análise!',
      showSuccessSwal: false,
    },
  }),
  computed: {
    document() {
      return this.analysisTable.client.cpfCnpj;
    },
  },
  watch: {
    document: {
      immediate: true,
      handler(document) {
        if (document) {
          this.getData();
        }
      },
    },
    loading: {
      immediate: true,
      handler(bool) {
        if (typeof bool === 'boolean') {
          this.handleClientInfo({
            loading: bool,
          });
        }
      },
    },
  },
  methods: {
    getData() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.requestClass.get(
          this.document,
        ),
        this.setPayload,
        this.requestConfig,
      );
    },
    setPayload(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.payload = this.overrideNullProperties(
          response.data,
        );
        this.handlePayloadForm();
      }
    },
    overrideNullProperties(data) {
      const referencePayload = this.payload;
      return Object.keys(data)
        .map(
          (key) => {
            const item = data[key];
            if (item === null) {
              return {
                [key]: referencePayload[key],
              };
            }
            return {
              [key]: item,
            };
          },
        ).reduce(
          (obj, crr) => ({ ...obj, ...crr }),
          {},
        );
    },
    handlePayloadForm() {
      this.$nextTick(
        () => {
          this.handleAnalysisTablePayload(
            this.payload,
          );
        },
      );
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          client: {
            cpfCnpj: '',
          },
        };
      },
    },
    handleAnalysisTablePayload: {
      default() {
        return (v) => v;
      },
    },
    handleClientInfo: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
